import { LinkedInOptOutModal } from "UserCrowd/components/linkedin/LinkedInOptOutModal"
import { LinkedInVerificationModal } from "UserCrowd/components/linkedin/LinkedInVerificationModal"
import React from "react"
import { useActionsDrawerContext } from "./ActionsDrawerContextProvider"

export const LinkedInModals: React.FC = () => {
  const {
    linkedInVerificationModalOpen,
    linkedinOptOutModalOpen,
    setLinkedInVerificationModalOpen,
    setLinkedInOptOutModalOpen,
  } = useActionsDrawerContext()

  const handleGetVerified = () => {
    setLinkedInVerificationModalOpen(true)
    setLinkedInOptOutModalOpen(false)
  }

  return (
    <>
      <LinkedInVerificationModal
        isOpen={linkedInVerificationModalOpen}
        onClose={() => setLinkedInVerificationModalOpen(false)}
        source="sidebar"
      />
      <LinkedInOptOutModal
        isOpen={linkedinOptOutModalOpen}
        onClose={() => setLinkedInOptOutModalOpen(false)}
        onGetVerified={handleGetVerified}
        source="sidebar"
      />
    </>
  )
}
